<svg
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M26.6666 35V31.6667C26.6666 29.8986 25.9643 28.2029 24.714 26.9526C23.4638 25.7024 21.7681 25 20 25H9.99998C8.23187 25 6.53618 25.7024 5.28593 26.9526C4.03569 28.2029 3.33331 29.8986 3.33331 31.6667V35"
    stroke="#1F4321"
    stroke-width="3.33333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M15 18.3333C18.6819 18.3333 21.6666 15.3486 21.6666 11.6667C21.6666 7.98477 18.6819 5 15 5C11.3181 5 8.33331 7.98477 8.33331 11.6667C8.33331 15.3486 11.3181 18.3333 15 18.3333Z"
    stroke="#1F4321"
    stroke-width="3.33333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M36.6667 35V31.6667C36.6656 30.1896 36.1739 28.7546 35.269 27.5872C34.364 26.4198 33.0969 25.586 31.6667 25.2167"
    stroke="#1F4321"
    stroke-width="3.33333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M26.6667 5.21667C28.1007 5.58384 29.3717 6.41784 30.2794 7.58719C31.1871 8.75654 31.6798 10.1947 31.6798 11.675C31.6798 13.1553 31.1871 14.5935 30.2794 15.7628C29.3717 16.9322 28.1007 17.7662 26.6667 18.1333"
    stroke="#1F4321"
    stroke-width="3.33333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
